



























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import UsersList from "@share/common/users-list/UsersList.vue";
import { getCountdownData, getDurationObjectFromNow } from '../CountdownHelpers';
import { declOfSum } from "@common/WordHelpers";

import { DateTime } from 'luxon'

@Component({
    components: { UsersList }
})

export default class SessionCountdown extends Vue {
    @Prop({ required: true }) targetDate: DateTime;

    initialState: any = {
        minutes: 'so',
        seconds: 'on'
    }

    countdownData: any = this.initialState;
    svgId = Date.now();

    coundownTimer: NodeJS.Timeout | null = null

    mounted() {
        this.setCountdown();
    }

    setCountdown() {

        // this.countdownData = this.initialState;

        //если до начала больше часа то не показывать ничего

        this.updateTime(this.targetDate);

        this.coundownTimer = setInterval(() => this.updateTime(this.targetDate), this.COUNTDOWN_UPDATE_INTERVAL);

    }

    updateTime(begin?: DateTime) {
        if(begin) {

            const durationData = getDurationObjectFromNow(begin);

            if(this.isBegan || typeof durationData.minutes === "undefined") {
                this.countdownData = this.initialState;
                this.$emit('began')
                return;
            }

            this.countdownData = getCountdownData(durationData);
        }

        this.$emit("update");
    }

    @Watch('targetDate')
    watchTargetDate() {
        this.updateTime(this.targetDate);
    }

    beforeDestroy() {
        if(this.coundownTimer) {
            clearInterval(this.coundownTimer);
        }
    }

    /**
     * get local string
     */
    getLS(key: string) {
        return this.$t(key).toString();
    }

    get minutes() {
        let titles = []
        if(this.lang === 'en') {
            titles = [this.getLS('program.minute'), this.getLS('program.minutes'), this.getLS('program.minutes')];
        }
        else {
            titles = [this.getLS('program.minute'), this.getLS('program.minutesGenitive'), this.getLS('program.minutes')];
        }

        return declOfSum(this.countdownData.minutes, titles).toLowerCase();
    }

    get seconds() {
        let titles = [];
        if(this.lang === 'en') {
            titles = [this.getLS('program.second'), this.getLS('program.seconds'), this.getLS('program.seconds')];
        }
        else {
            titles = [this.getLS('program.second'), this.getLS('program.secondsGenitive'), this.getLS('program.seconds')];
        }

        return declOfSum(this.countdownData.seconds, titles).toLowerCase();
    }

    get isBegan() {
        return this.targetDate < DateTime.local().minus({minutes: 1}) || !this.targetDate;
    }

    get COUNTDOWN_UPDATE_INTERVAL() {
        return 1 * 1000;
    }

    get lang() {
        return this.$store.state.session?.language ?? 'en';
    }
}
